import React from 'react'
import styled from '../../constants/theme'
import { FormElementProps } from './FormElementParts'

interface State {
  checked: boolean
}

class CheckboxElement extends React.Component<FormElementProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.value === 'true',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setChecked(this.props.value)
    }
  }

  handleChange = e => {
    const { name } = this.props
    const value = e.target.checked ? 'true' : 'false'
    const { onChange } = this.props
    if (onChange) {
      onChange({ name, value })
    }
    this.setChecked(value)
  }

  setChecked = value => {
    this.setState({
      checked: value === 'true',
    })
  }

  render() {
    const { disabled, isRequired, label, name, type } = this.props
    const { checked } = this.state
    const labelId = `label-${name}`
    return (
      <Checkbox>
        <CheckboxInput
          aria-checked={checked}
          aria-labelledby={labelId}
          checked={checked}
          disabled={disabled}
          id={name}
          name={name}
          onChange={this.handleChange}
          required={isRequired}
          type={type}
        />
        <Label
          htmlFor={name}
          id={labelId}
          title={label}
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        ></Label>
        <Box className="box">
          <Checkmark />
        </Box>
      </Checkbox>
    )
  }
}

const CheckboxInput = styled.input({
  '&:disabled': {
    cursor: 'not-allowed',
  },
  '&:hover': {
    cursor: 'pointer',
  },
  height: '100%',
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  width: 16,
  zIndex: 1,
})

const Label = styled.label({
  '&:hover:before': {
    cursor: 'pointer',
  },
  '&:before': {
    content: '""',
    height: 28,
    left: -6,
    position: 'absolute',
    top: -6,
    width: 28,
  },
  '& a': {
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
})

export const Box = styled.div(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: 16,
  width: 16,
  borderRadius: theme.borderRadiusSmall,
  border: `1px solid ${theme.primaryDark}`,
}))

const Checkmark = styled.div(({ theme }) => ({
  '[aria-checked="true"] ~ .box &': {
    display: 'inline-block',
  },
  display: 'none',
  transform: 'rotate(45deg)',
  height: 12,
  width: 6,
  marginLeft: 4,
  marginBottom: 2,
  borderBottom: `medium solid ${theme.textLight}`,
  borderRight: `medium solid ${theme.textLight}`,
}))

const Checkbox = styled.li(
  {
    display: 'inline-block',
    height: 18,
    lineHeight: 1.1,
    paddingLeft: 40,
    position: 'relative',
    width: '100%',
  },
  ({ theme }) => ({
    color: theme.text,
    fontFamily: theme.fontFamily,
  }),
)

export default CheckboxElement
